__turbopack_context__.v({
  "FloatingWidgetContainer": "floatingWidget-module-scss-module__dPNOsq__FloatingWidgetContainer",
  "expanded": "floatingWidget-module-scss-module__dPNOsq__expanded",
});
